/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { SignUpModalDuvidas as SignUpModalDuvidasContainer } from 'redesign/components/molecules/SignUpModalDuvidas'
import illustrationDuvidas from 'assets/illustration-unico-modal.svg'

type SignUpModalDuvidasProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
}

export const SignUpModalDuvidas = ({ setShowModal, showModal }: SignUpModalDuvidasProps) => (
    <SignUpModalDuvidasContainer
        setShowModal={() => {
            setShowModal(!showModal)
        }}
        showModal={showModal}
        title="Dúvida pra validar a conta?"
    >
        <p>
            Você pode receber <strong>ajuda online</strong> do nosso time de atendimento pra atualizar seus dados.
        </p>
        <p>
            <span>É só clicar no botão "Acessar WhatsApp"</span>
        </p>
        <br />
        <div className="container_illustration">
            <img alt="Ilustrção smartphone" src={illustrationDuvidas} />
        </div>
    </SignUpModalDuvidasContainer>
)
